<template>
    <div class="text-end me-4">
        <IconComp
            v-if="row.DeviceStatus?.Channel"
            :icon="getChannel(row.DeviceStatus?.Channel)"
            class="text-info"
        ></IconComp>

        <span
            v-for="(antenna, i) in row.DeviceStatus?.Antennas"
            :key="i"
        >
            <IconComp
                v-if="!antenna.IsInternal"
                :icon="antenna.Connected ? 'fa-circle-plus' : 'fa-circle'"
                :class="antenna.Connected ? 'text-success-emphasis' : 'text-danger'"
                class="ms-2"
                :title="$tm('devicestatus.externalantenna')"
            ></IconComp>
            <IconComp
                v-else
                :icon="antenna.Connected ? 'fa-square-plus' : 'fa-square'"
                :class="antenna.Connected ? 'text-success-emphasis' : 'text-danger'"
                :title="$tm('devicestatus.internalantenna')"
                class="ms-2"
            ></IconComp>
        </span>
    </div>
</template>

<script lang="ts" setup>
import { IconComp } from '@/components';
import type { StationDeviceStatus } from '@/objects/generated';

const props = defineProps<{
    row: StationDeviceStatus;
}>();

/**
 * Get the correct channel text
 * @param channel
 */
const getChannel = (channel?: string | null): string => {
    if (channel == null) {
        return '';
    }

    return 'fa-square-' + channel?.toLowerCase();
};
</script>
